import React from 'react';

import classNames from 'classnames';

import classes from './ReleasePlatformCell.module.scss';
import { GridTableCell } from '../../../../../shared/components/table-components';
import { ReleasePlatformType } from '../../../../constants/releasePlatform';
import { getHumanizeReleasePlatform } from '../../../../utils/getHumanizeReleasePlatform/getHumanizeReleasePlatform';

type ReleasePlatformCellProps = {
  platform: ReleasePlatformType;
};

const ReleasePlatformCell = ({ platform }: ReleasePlatformCellProps) => {
  const platformName = getHumanizeReleasePlatform(platform);

  return (
    <GridTableCell className={classes.platformCell} variant="title">
      <span className={classNames(classes.platformIcon, classes[platform])} aria-hidden>
        {platformName.charAt(0)}
      </span>
      {platformName}
    </GridTableCell>
  );
};

export { ReleasePlatformCell };
